import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { theme } from './theme';
import { MainLayout } from './layouts/MainLayout';
import { ProtectedRoute } from './routes/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { HoldingPage } from './pages/HoldingPage';
import { HomePage } from './pages/HomePage';
import { LogsPage } from './pages/LogsPage';
import { UsersPage } from './pages/UsersPage';
import { GroupsPage } from './pages/GroupsPage';
import { RolesPage } from './pages/RolesPage';
import { RightsPage } from './pages/RightsPage';
import { StravaPage } from './pages/StravaPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { AcceptInvitePage } from './pages/AcceptInvitePage';
import { ErrorBoundary } from './components/ErrorBoundary';

export function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          {/* Public routes — no app chrome, no menu. */}
          <Route path="/" element={<HoldingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/accept-invite" element={<AcceptInvitePage />} />

          {/* Authenticated app — MainLayout owns the menu. */}
          <Route element={<ProtectedRoute />}>
            <Route element={<MainLayout />}>
              <Route path="/home" element={<HomePage />} />
              <Route path="/change-password" element={<ErrorBoundary><ChangePasswordPage /></ErrorBoundary>} />

              {/* Per-route rights gates — mirror the server's .RequireRight policy
                  on the matching endpoint. Missing the right bounces to /home. */}
              <Route element={<ProtectedRoute requireRight="users.read.list" />}>
                <Route path="/users" element={<ErrorBoundary><UsersPage /></ErrorBoundary>} />
              </Route>
              <Route element={<ProtectedRoute requireRight="groups.read.list" />}>
                <Route path="/groups" element={<ErrorBoundary><GroupsPage /></ErrorBoundary>} />
              </Route>
              <Route element={<ProtectedRoute requireRight="roles.read.list" />}>
                <Route path="/roles" element={<ErrorBoundary><RolesPage /></ErrorBoundary>} />
              </Route>
              <Route element={<ProtectedRoute requireRight="rights.read.list" />}>
                <Route path="/rights" element={<ErrorBoundary><RightsPage /></ErrorBoundary>} />
              </Route>
              <Route element={<ProtectedRoute requireRight="logs.read.query" />}>
                <Route path="/logs" element={<ErrorBoundary><LogsPage /></ErrorBoundary>} />
              </Route>
              <Route element={<ProtectedRoute requireRight="strava.read.status" />}>
                <Route path="/strava" element={<ErrorBoundary><StravaPage /></ErrorBoundary>} />
              </Route>

              {/* Unknown authenticated paths → home. */}
              <Route path="*" element={<Navigate to="/home" replace />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
